import { uapiFetcher } from 'util/UAPI';
import { PROGRAM_INSTANCE_QUERY } from './query';
import { trackError } from 'util/error';
import { ProgramInstanceData } from './types';

export const fetchProgramInstance = async (programInstanceUuid: string) => {
  try {
    return await uapiFetcher<ProgramInstanceData>(PROGRAM_INSTANCE_QUERY, { id: programInstanceUuid });
  } catch (error) {
    trackError(new TypeError('Could not fetch "ProgramInstance" query from UAPI'), { error });
    throw error;
  }
};
